<template>
  <el-dialog
    id="extendDialog"
    :title="['extend', 'extendInner'].includes(mode)
      ? $t('customAlert.extension.extendEngagement') : $t('customAlert.extension.startEngagement')"
    :visible.sync="showLocal"
    :width="dialogWidth"
  >
    <div
      v-if="mode === 'extendInner'"
      class="innerModeDesc"
    >
      {{ $t('customAlert.extension.pleaseExtend') }}
    </div>

    <!-- Current engagement information -->
    <el-row
      v-if="['extend', 'extendInner'].includes(mode)"
      class="dataRow"
      :gutter="10"
      type="flex"
      style="flex-wrap: wrap;"
    >
      <el-col
        :span="24"
        :sm="12"
        :md="8"
      >
        <div class="subTitle">
          {{ $t('customAlert.extension.coachName') }}
        </div>
        <div>
          {{ extensionNotice.coach_name }}
        </div>
      </el-col>
      <el-col
        :span="24"
        :sm="12"
        :md="8"
      >
        <div class="subTitle">
          {{ $t('customAlert.extension.currentDuration') }}
        </div>
        <div>
          {{ extensionNotice.display_curr_duration }}
        </div>
      </el-col>
    </el-row>

    <div
      v-if="durationList"
      class="durationSelectorWrap"
    >
      <div class="durationText">
        <span v-if="['extend', 'extendInner'].includes(mode)">
          {{ $t('customAlert.extension.selectExtendDuration') }}:
        </span>
        <span v-else>
          {{ $t('customAlert.extension.selectEngagementDuration') }}:
        </span>
      </div>
      <el-select
        v-model="selectedDuration"
        class="durationSelector"
        :placeholder="$t('customAlert.extension.selectDuration')"
        filterable
        value-key="id"
      >
        <el-option
          v-for="duration in durationList"
          :key="`Duration${duration.id}`"
          :label="duration.text"
          :value="duration.id"
        />
      </el-select>
    </div>

    <div class="dataRow">
      <!-- 1 row -->
      <p v-if="['extend', 'extendInner'].includes(mode)">
        {{ $t('customAlert.extension.willUpdate') }}
      </p>
      <p v-else>
        {{ $t('customAlert.extension.willGetContact') }}
      </p>
      <!-- 2 row -->
      <p>
        <i18n path="customAlert.extension.footer">
          <template #email>
            Support@GlobalCoachGroup.com
          </template>
        </i18n>
      </p>
    </div>

    <div class="dataRow actionWrap">
      <el-button
        round
        :disabled="processLoading"
        @click="showLocal = false"
      >
        {{ $t('common.cancel') }}
      </el-button>

      <el-button
        v-if="['extend', 'extendInner'].includes(mode)"
        type="primary"
        round
        :loading="processLoading"
        @click="toggleExtend"
      >
        <span>
          {{ $t('customAlert.extension.extend') }}
        </span>
      </el-button>

      <el-button
        v-else
        type="primary"
        round
        :loading="processLoading"
        @click="toggleStart"
      >
        <span>
          {{ $t('common.start') }}
        </span>
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import api from '@/api';
import dialog from '@/mixins/dialog';

export default {
  name: 'ExtendDialog',

  mixins: [
    dialog,
  ],

  props: {
    extensionNotice: {
      type: Object,
      default: null,
    },

    mode: {
      type: String,
      default: 'extend',
    },
  },

  data: () => ({
    processLoading: false,
    selectedDuration: 13,
  }),

  computed: {
    durationList() {
      const base = [4, 7, 10, 13];
      let list = [];

      if (this.extensionNotice && this.extensionNotice.curr_duration) {
        if (this.extensionNotice.curr_duration !== 13) {
          list = base
            .filter((el) => el > this.extensionNotice.curr_duration)
            .map((el) => ({ text: `${el} ${this.$t('customAlert.extension.sessions')} (${el - 1} ${this.$t('customAlert.extension.monthShort')})`, id: el }));
        } else {
          list = base
            .map((el) => ({ text: `${el} ${this.$t('customAlert.extension.sessions')} (${el - 1} ${this.$t('customAlert.extension.monthShort')})`, id: el }));
        }
      }

      return list;
    },
  },

  methods: {
    ...mapActions('processStatus', [
      'fetchProcess',
    ]),

    async toggleExtend() {
      try {
        this.processLoading = true;
        const sendData = { new_duration: this.selectedDuration };
        await api.postProcessStatus(sendData);
        this.fetchProcess();
        this.showLocal = false;
        this.$message.success(this.$t('customAlert.extension.extensionSubmitted'));
      } catch (err) {
        console.log(err);
        this.$message.error(err.msg);
      } finally {
        this.processLoading = false;
      }
    },

    async toggleStart() {
      try {
        this.processLoading = true;
        const sendData = { duration: this.selectedDuration };
        await api.postNewEngagement(sendData);
        this.fetchProcess();
        this.showLocal = false;
        this.$message.success(this.$t('customAlert.extension.newEngagementSubmitted'));
      } catch (err) {
        console.log(err);
        this.$message.error(err.msg);
      } finally {
        this.processLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
  #extendDialog {
    .innerModeDesc {
      word-break: break-word;
      margin: 10px 0 15px;
    }

    .subTitle {
      color: #003865;
      font-weight: bold;
      margin: 5px 0;
    }

    .actionWrap {
      display: flex;
      justify-content: center;
    }

    .el-dialog__body {
      padding: 10px 20px 20px;
    }

    .durationSelectorWrap {
      padding: 18px 0 10px;
      .durationText {
        padding: 0 0 10px;
      }
      .durationSelector {
        .el-input__inner {
          border-radius: 5px;
        }
      }
    }
  }
</style>
